import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {commonHeaders} from '../../../actions/fetch.util';
import {Button, ButtonGroup, PageDescription, PageForm} from '../../Common/PageComponents';

class IdSearchForm extends Component {
  _findUserName(e) {
    e.preventDefault();
    if (!this.ownerName.value || !this.businessLicenseNumber.value) {
      alert('대표자 성명과 사업자등록번호를 모두 입력해주세요.');
      return;
    }
    fetch(
      `${API_URL}/users/by-owner-name/${this.ownerName.value}/by-business-license-number/${this.businessLicenseNumber.value}/username`,
      {
        headers: commonHeaders(),
      }
    )
      .then(response => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 404) {
          return;
        } else {
          throw new Error();
        }
      })
      .catch(() => alert('아이디 검색에 실패했습니다.'))
      .then(result => {
        if (result) {
          this.props.history.push(
            `/member-service/id-search/result?userName=${result.userName}&created=${result.created}&pcBangName=${result.pcBangName}`
          );
        } else {
          this.props.history.push(`/member-service/id-search/result`);
        }
      });
  }

  render() {
    return (
      <div>
        <PageForm theme={'box'} style={{margin: '50px auto'}}>
          <form action="/member-service/id-search/result" method="post" name="frm">
            <dl>
              <dt>대표자 성명</dt>
              <dd>
                <input
                  type="text"
                  className="input_text"
                  name="userName"
                  id="userName"
                  maxLength="25"
                  autoComplete="off"
                  style={{width: '250px'}}
                  ref={node => (this.ownerName = node)}
                />
              </dd>
              <dt>사업자 등록번호</dt>
              <dd>
                <input
                  type="text"
                  className="input_text"
                  name="pe1"
                  maxLength="13"
                  style={{width: '250px'}}
                  placeholder=" 예) 123-45-67890"
                  autoComplete="off"
                  ref={node => (this.businessLicenseNumber = node)}
                />
              </dd>
            </dl>
            <input type="hidden" name="${_csrf.parameterName}" value="${_csrf.token}" />
          </form>
          <ButtonGroup>
            <Button onClick={e => this._findUserName(e)}>확인</Button>
          </ButtonGroup>
        </PageForm>
        <PageDescription>
          <img src="/image/member/pw_s_ok.gif" alt="" /> ‘사업자등록증 미발급’ 선택을 통해 회원가입하신 분들은{' '}
          <b>고객센터(1688-1011)</b>로 문의 주시기 바랍니다.
        </PageDescription>
      </div>
    );
  }
}

export default withRouter(connect()(IdSearchForm));
